import {Injectable} from '@angular/core';
import {Response, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Message} from '../models/message';
import 'rxjs/add/operator/map';

@Injectable()
export class MessagingService {

  private url: string = `${ environment.apiRoot }/message/`;
  private urlprofileCompletionRequest: string = `${ environment.apiRoot }/requestprofilecompletion/`;
  private urlMsgDirect: string = `${ environment.apiRoot }/message/`;
  private urlMsgMassive: string = `${ environment.apiRoot }/massivemessage/`;
  constructor(private http: HttpAuth) { }

  public send(jobId: string, message:Message, userId?: string): Observable<any> {
    let params = { job_id: jobId, title: message.subject, content: message.description };
    if(userId){
        params['user_id'] = userId;
    }

    if(status){
        params['status'] = status;
    }

    const body = JSON.stringify(params);

    return this.http.post(this.url, body)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public sendMassive(jobId: string, message:Message, userId?: string,  favorite?: boolean, status?: any): Observable<any> {

    let params = { job_id: jobId, title: message.subject, content: message.description };

    if(userId){
        params['user_id'] = userId;
    }

    if (status) {
        params['status'] = status;
    }

    if (favorite) {
        params['favorite'] = String(favorite);
    }

    const body = JSON.stringify(params);

    return this.http.post(this.urlMsgMassive, body)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public sendprofileCompletionRequest(userId: string, jobId?: string): Observable<any> {
    let body = ''   ;
    if (jobId != null){
        body = JSON.stringify({ user_id: userId, job_id: jobId});
    }else{
        body = JSON.stringify({ user_id: userId});
    }
    return this.http.post(this.urlprofileCompletionRequest, body)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getMessage(userId:string, jobId?:string, page?:number, pagecount?: number): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('user_id', userId);

    if(jobId) {
      params.append('job_id', jobId);
    }

    if(page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if(pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    let options = new RequestOptions({search: params});

    return this.http.get(this.url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getMessagesDirect(page: number, pagecount: number,
                           query?: string, favorite?: string, status?: any[], jobId?: string, req?:number): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();

    if(jobId){
        params.set('job_id',jobId);
    }
    if(query){
        params.set('query',query);
    }
    if(favorite){
        params.set('favorite',favorite);
    }

    params.set('page', String(page));
    params.set('pagecount', String(pagecount));

    if(status){
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    let options = new RequestOptions({search: params});

    return this.http.get(this.urlMsgDirect, options)
      .map(this.extractData)
      .catch((error:any) => Observable.throw(error.json().meta || {message:'server error', status:0}));
  }

  public getMessagesMassive(page: number, pagecount: number,
                            query?: string, favorite?: string, status?: any[], jobId?: string, req?:number): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();

    if(jobId){
        params.set('job_id',jobId);
    }
    if(query){
        params.set('query',query);
    }
    if(favorite){
        params.set('favorite',favorite);
    }

    params.set('page', String(page));
    params.set('pagecount', String(pagecount));

    if(status){
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    let options = new RequestOptions({search: params});

    return this.http.get(this.urlMsgMassive, options)
      .map(this.extractData)
      .catch((error:any) => Observable.throw(error.json().meta || {message:'server error', status:0}));
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/messaging.service.ts